import './BannedUser.scss'
import React from 'react'
import { observer } from 'mobx-react'
import { teamStore } from '../../app/stores'
import { Banner, Button } from '../../lib'
import moment from 'moment'

const BannedUser = ({ ban }) => {
  const changeBan = () => teamStore.changeBan(ban.ipAddress, !ban.banned)
  return (
    <Banner className="BannedUser" title={ban.ipAddress} frown={ban.banned}>
      Originally banned on {moment(ban.timeCreated.replace(/"/g, '')).format('MMM Do')}
      <Button onClick={changeBan} small>
        {ban.banned ? 'Unban' : 'Reban'}
      </Button>
    </Banner>
  )
}

BannedUser.displayName = 'BannedUser'

export default observer(BannedUser)



// WEBPACK FOOTER //
// ./src/dashboard/banned/BannedUser.js